export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              移动端畅读
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              51漫画网提供移动端专属适配方案，让您随时随地畅享高清漫画。无论是在通勤路上还是休闲时光，
              只需打开51漫画网页版移动端，即可获得流畅的翻页体验与清晰的画质呈现。
              支持iOS与Android设备，无需下载即可阅读，节省手机存储空间，同时提供收藏与历史记录功能，
              让您的阅读之旅更加便捷。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('hero');
                  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-foreground-900 text-background-50 font-medium rounded-full text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-apple-fill mr-2"></i>
                iOS 入口
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById('hero');
                  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-accent-500 text-background-50 font-medium rounded-full text-sm hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-android-fill mr-2"></i>
                Android 入口
              </a>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-56 h-96 rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20manga%20reading%20app%20interface%20on%20a%20warm%20cream%20background%2C%20Japanese%20comic%20style%20illustrations%20on%20screen%2C%20clean%20modern%20UI%20design%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%20with%20peach%20and%20warm%20gray%20tones&width=600&height=1000&seq=app-mobile-01&orientation=portrait"
                alt="51漫画网移动端阅读界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}